var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"value":_vm.value,"size":_vm.size},on:{"input":_vm.handleInput}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t("message.select_option")))]),_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.social_platform}},[_vm._v(_vm._s(option.social_platform))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }